<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div class="search-con-top">
            <Select v-model="filterStatus" clearable placeholder="审核状态" style="width:120px">
              <Option :value="0">待审核</Option>
              <Option :value="1">已通过</Option>
              <Option :value="2">已驳回</Option>
            </Select>
            <Input class="search-input" v-model="searchVal" style="width:250px" clearable placeholder="企业名称/手机号搜索"
                   @on-enter="searchinput"/>
            <Button type="primary" @click="searchinput">搜索</Button>
            <Button type="default" @click="refreshData">刷新</Button>
          </div>
        </Card>
      </i-col>
    </Row>

    <!-- 汇总指标栏 -->
    <Row :gutter="10" style="margin-bottom: 10px;">
      <i-col :xs="12" :sm="6">
        <Card :bordered="false" :padding="0">
          <div class="stat-card stat-pending">
            <div class="stat-num">{{ stats.pending }}</div>
            <div class="stat-label">待审核</div>
          </div>
        </Card>
      </i-col>
      <i-col :xs="12" :sm="6">
        <Card :bordered="false" :padding="0">
          <div class="stat-card stat-approved">
            <div class="stat-num">{{ stats.approved }}</div>
            <div class="stat-label">已通过</div>
          </div>
        </Card>
      </i-col>
      <i-col :xs="12" :sm="6">
        <Card :bordered="false" :padding="0">
          <div class="stat-card stat-rejected">
            <div class="stat-num">{{ stats.rejected }}</div>
            <div class="stat-label">已驳回</div>
          </div>
        </Card>
      </i-col>
      <i-col :xs="12" :sm="6">
        <Card :bordered="false" :padding="0">
          <div class="stat-card stat-total">
            <div class="stat-num">{{ stats.total }}</div>
            <div class="stat-label">总数</div>
          </div>
        </Card>
      </i-col>
    </Row>

    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table height="600" size="small" border striped :columns="columns" :data="tableData"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
        </Card>
      </i-col>
    </Row>

    <!-- 审核详情弹窗 -->
    <Modal v-model="detailModalVisible" :title="detailModalTitle" :footer-hide="true" :mask-closable="false" width="800">
      <div v-if="currentRecord" class="audit-detail">
        <!-- 审核状态标签 -->
        <div class="status-badge" :class="'status-' + currentRecord.audit_status">
          {{ currentRecord.audit_status_cn }}
        </div>

        <!-- 企业信息 -->
        <div class="detail-section">
          <h4>企业信息</h4>
          <Row :gutter="16">
            <i-col span="12">企业名称：{{ currentRecord.company ? currentRecord.company.name : '-' }}</i-col>
            <i-col span="12">统一社会信用代码：{{ currentRecord.company ? currentRecord.company.code : '-' }}</i-col>
            <i-col span="12">法定代表人：{{ currentRecord.company ? currentRecord.company.legal_person : '-' }}</i-col>
            <i-col span="12">行业：{{ currentRecord.company ? currentRecord.company.industry_cn : '-' }}</i-col>
            <i-col span="12">企业类型：{{ currentRecord.company ? currentRecord.company.type_cn : '-' }}</i-col>
            <i-col span="12">企业规模：{{ currentRecord.company ? currentRecord.company.scale_cn : '-' }}</i-col>
            <i-col span="24">地址：{{ currentRecord.company ? currentRecord.company.address : '-' }}</i-col>
            <i-col span="24">简介：{{ currentRecord.company ? currentRecord.company.introduce : '-' }}</i-col>
          </Row>
        </div>

        <!-- 提交人信息 -->
        <div class="detail-section">
          <h4>提交人信息</h4>
          <Row :gutter="16">
            <i-col span="12">昵称：{{ currentRecord.user_nickname || '-' }}</i-col>
            <i-col span="12">手机号：{{ currentRecord.user_tel || '-' }}</i-col>
            <i-col span="12">提交时间：{{ currentRecord.submit_time || '-' }}</i-col>
          </Row>
        </div>

        <!-- 附件列表 -->
        <div class="detail-section">
          <h4>上传资料</h4>
          <div v-if="currentRecord.files && currentRecord.files.length > 0" class="file-list">
            <div v-for="f in currentRecord.files" :key="f.id" class="file-item">
              <span class="file-type-tag">{{ f.file_type_cn }}</span>
              <span class="file-name">{{ f.file_name }}</span>
              <Button type="text" size="small" @click="previewFile(f)">查看</Button>
            </div>
          </div>
          <div v-else class="no-data">暂无附件</div>
        </div>

        <!-- 审核结果（仅非待审核显示） -->
        <div v-if="currentRecord.audit_status !== 0" class="detail-section">
          <h4>审核结果</h4>
          <Row :gutter="16">
            <i-col span="12">审核人：{{ currentRecord.auditor_name || '-' }}</i-col>
            <i-col span="12">审核时间：{{ currentRecord.audit_time || '-' }}</i-col>
            <i-col span="24" v-if="currentRecord.audit_status === 2">
              驳回原因：<span class="reject-reason">{{ currentRecord.reject_reason }}</span>
            </i-col>
            <i-col span="24" v-if="currentRecord.audit_remark">
              审核备注：{{ currentRecord.audit_remark }}
            </i-col>
          </Row>
        </div>

        <!-- 审核操作（待审核状态显示） -->
        <div v-if="currentRecord.audit_status === 0" class="detail-section audit-action-section">
          <h4>审核操作</h4>
          <Form :label-width="100">
            <FormItem label="审核备注">
              <Input v-model="auditRemark" type="textarea" :rows="2" placeholder="可选，填写审核备注"/>
            </FormItem>
            <FormItem label="驳回原因" v-if="showRejectForm">
              <Input v-model="rejectReason" type="textarea" :rows="3" placeholder="请填写驳回原因，必填"/>
            </FormItem>
          </Form>
          <div class="action-buttons">
            <Button type="primary" @click="handleAudit('pass')" :loading="actionLoading">通过</Button>
            <Button type="error" @click="showRejectForm = true" v-if="!showRejectForm">驳回</Button>
            <template v-if="showRejectForm">
              <Button type="primary" @click="handleAudit('reject')" :loading="actionLoading">确认驳回</Button>
              <Button @click="cancelReject">取消</Button>
            </template>
            <Button @click="detailModalVisible = false" style="margin-left:8px">关闭</Button>
          </div>
        </div>

        <!-- 已审核状态的关闭按钮 -->
        <div v-if="currentRecord.audit_status !== 0" class="action-buttons" style="margin-top:16px;">
          <Button @click="detailModalVisible = false">关闭</Button>
        </div>
      </div>
    </Modal>

    <!-- 图片预览 -->
    <Modal v-model="imgPreviewVisible" title="资料预览" :footer-hide="true" width="800">
      <img :src="imgPreviewUrl" style="width:100%;max-height:70vh;"/>
    </Modal>
  </div>
</template>

<script>
import {
  getCompanyAuditList,
  getCompanyAuditDetail,
  companyAuditAction
} from '@/api/company/company_audit.js'

export default {
  data() {
    return {
      spinShow: false,
      searchVal: '',
      filterStatus: null,
      tableData: [],
      pageTotal: 0,
      pageNum: 1,
      pageSize: 15,
      stats: {
        total: 0,
        pending: 0,
        approved: 0,
        rejected: 0
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
          tooltip: true
        },
        {
          title: '企业名称',
          key: 'company_name',
          width: 300,
          tooltip: true,
          render: (h, params) => {
            const name = params.row.company_name || '-'
            const flag = params.row.company_flag
            if (flag === 1) {
              return h('span', { style: { color: '#f5222d' } }, name + '(已删除)')
            }
            return h('span', name)
          }
        },
        {
          title: '统一信用代码',
          key: 'credit_code',
          width: 180,
          tooltip: true
        },
        {
          title: '法定代表人',
          key: 'legal_person',
          width: 100,
          tooltip: true
        },
        {
          title: '行业',
          key: 'industry_cn',
          width: 120,
          tooltip: true
        },
        {
          title: '提交人',
          key: 'user_nickname',
          width: 100,
          tooltip: true
        },
        {
          title: '手机号',
          key: 'user_tel',
          width: 120,
          tooltip: true
        },
        {
          title: '提交时间',
          key: 'submit_time',
          width: 160,
          tooltip: true
        },
        {
          title: '审核状态',
          key: 'audit_status_cn',
          width: 100,
          tooltip: true,
          render: (h, params) => {
            const status = params.row.audit_status
            const color = status === 0 ? 'warning' : (status === 1 ? 'success' : 'error')
            return h('Tag', { props: { color: color, type: 'border' } }, params.row.audit_status_cn)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: 'right',
          render: (h, params) => {
            return h('Button', {
              props: { type: 'primary', size: 'small' },
              on: { click: () => this.showDetail(params.row) }
            }, '查看')
          }
        }
      ],
      detailModalVisible: false,
      detailModalTitle: '审核详情',
      currentRecord: null,
      auditRemark: '',
      rejectReason: '',
      showRejectForm: false,
      actionLoading: false,
      imgPreviewVisible: false,
      imgPreviewUrl: ''
    }
  },
  methods: {
    searchinput() {
      this.pageNum = 1
      this.getData()
    },
    changePage(page) {
      this.pageNum = page
      this.getData()
    },
    handlePageSize(size) {
      this.pageSize = size
      this.getData()
    },
    async getData() {
      this.spinShow = true
      try {
        const params = {
          page: this.pageNum,
          limit: this.pageSize
        }
        if (this.filterStatus !== null && this.filterStatus !== '') {
          params.audit_status = this.filterStatus
        }
        if (this.searchVal.trim()) {
          params.keyword = this.searchVal.trim()
        }
        const res = await getCompanyAuditList(params)
        if (res.data.code === 0) {
          this.tableData = res.data.data || []
          this.pageTotal = res.data.count || 0
          if (res.data.stats) {
            this.stats = res.data.stats
          }
        }
      } finally {
        this.spinShow = false
      }
    },
    async showDetail(row) {
      this.spinShow = true
      try {
        const res = await getCompanyAuditDetail({ id: row.id })
        if (res.data.code === 0) {
          this.currentRecord = res.data.data
          this.auditRemark = ''
          this.rejectReason = ''
          this.showRejectForm = false
          this.detailModalVisible = true
        } else {
          this.$Message.error(res.data.msg || '获取详情失败')
        }
      } finally {
        this.spinShow = false
      }
    },
    showRejectFormToggle() {
      this.showRejectForm = true
    },
    cancelReject() {
      this.showRejectForm = false
      this.rejectReason = ''
    },
    async handleAudit(action) {
      if (action === 'reject' && !this.rejectReason.trim()) {
        this.$Message.warning('请填写驳回原因')
        return
      }
      this.actionLoading = true
      try {
        const res = await companyAuditAction({
          id: this.currentRecord.id,
          action: action,
          reject_reason: this.rejectReason.trim(),
          audit_remark: this.auditRemark.trim()
        })
        if (res.data.code === 0) {
          this.$Message.success(res.data.msg || '操作成功')
          this.detailModalVisible = false
          this.getData()
        } else {
          this.$Message.error(res.data.msg || '操作失败')
        }
      } finally {
        this.actionLoading = false
      }
    },
    previewFile(file) {
      let url = file.file_path || ''
      if (url && !/^https?:\/\//i.test(url)) {
        url = url
      }
      this.imgPreviewUrl = url
      this.imgPreviewVisible = true
    },
    loadStats() {
      // stats 已集成在 getData() 中一并返回
    },
    refreshData() {
      this.pageNum = 1
      this.getData()
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
.audit-detail {
  max-height: 65vh;
  overflow-y: auto;
}
.status-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
}
.status-0 { background: #fff3e0; color: #ed6c00; border: 1px solid #ed6c00; }
.status-1 { background: #f0f9eb; color: #52c41a; border: 1px solid #52c41a; }
.status-2 { background: #fff1f0; color: #f5222d; border: 1px solid #f5222d; }
.detail-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}
.detail-section:last-child {
  border-bottom: none;
}
.detail-section h4 {
  margin-bottom: 12px;
  color: #333;
  font-size: 14px;
}
.detail-section .ivu-col {
  margin-bottom: 8px;
  color: #666;
  font-size: 13px;
}
.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #fafafa;
  border-radius: 4px;
}
.file-type-tag {
  background: #D4AF37;
  color: #fff;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.file-name {
  flex: 1;
  color: #666;
  font-size: 13px;
}
.no-data {
  color: #999;
  font-size: 13px;
}
.reject-reason {
  color: #f5222d;
  font-weight: bold;
}
.audit-action-section {
  background: #fafafa;
  padding: 16px;
  border-radius: 4px;
}
.action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.search-con-top {
  display: flex;
  align-items: center;
  gap: 10px;
}
.stat-card {
  text-align: center;
  padding: 20px 0;
}
.stat-num {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
}
.stat-label {
  font-size: 14px;
  margin-top: 4px;
  color: #666;
}
.stat-pending .stat-num { color: #ed6c00; }
.stat-approved .stat-num { color: #52c41a; }
.stat-rejected .stat-num { color: #f5222d; }
.stat-total .stat-num { color: #1890ff; }
</style>